import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConditionalClassDirective } from './conditional-class.directive';

@NgModule({
  exports: [ConditionalClassDirective],
  imports: [CommonModule, ConditionalClassDirective],
})
export class ConditionalClassModule {}
